import { PAD_ITEM_TYPE } from 'app/config/pad_item.js';
export default class BuildPadItem {
  constructor(padItem) {
    this._padItem = padItem;
    this._padItem.name = padItem.name;
    this._padItem.type = PAD_ITEM_TYPE.EQUIPMENT;
  }

  addPadItemCode = function (code) {
    this._padItem.code = code;

    return this;
  };

  addPadItemType = function (type) {
    this._padItem.type = type;

    return this;
  };

  addPadItemAlterId = function (padItemAlterId) {
    this._padItem.padItemAlterId = padItemAlterId;

    return this;
  };

  addStatus = function (status) {
    this._padItem.status = status;

    return this;
  };

  setUpdateStatus = function () {
    this._padItem.itHasBeenUpdated = true;

    return this;
  };

  // addPadCardType = function (padCardType) {
  //   this._padItem.padCardType = padCardType;

  //   return this;
  // };

  getPadItem = function () {
    return this._padItem;
  };

  cleanPadItem = function (callback) {
    const { frequency, visitationType, profession, responsible } = this._padItem;

    this._padItem.frequency = callback(frequency, ['id', 'name']);
    this._padItem.visitationType = callback(visitationType, ['id', 'name']);
    this._padItem.profession = callback(profession, ['id', 'name']);
    this._padItem.responsible = callback(responsible, ['id', 'name']);

    delete this._padItem.id;
    delete this._padItem.code;
    //delete this._padItem.PadItemType;
    delete this._padItem.PadItemAlterId;

    delete this._padItem.pad;
    delete this._padItem.padId;

    delete this._padItem.prescription;
    delete this._padItem.PadItemAlter;
    delete this._padItem.preferedShift;
    delete this._padItem.preferedWeekDays;

    delete this._padItem.created;
    delete this._padItem.updated;

    this._padItem.PadItemAlterId = null;

    return this;
  };
}
